// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/appvue." + {"372": "6ead8d43","624": "d07fe1a6","66": "dc6a01bc","714": "12be4cc0","739": "8c6b93ee",}[chunkId] + ".js"
}